
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directory/year/[year]/week/[week]",
      function () {
        return require("private-next-pages/directory/year/[year]/week/[week].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directory/year/[year]/week/[week]"])
      });
    }
  